import map from 'lodash/map'
import mapValues from 'lodash/mapValues'
import { getRandomDigitString } from 'utils/domain/FormBuilder/FormBuilderQuestion'

import { increasePageOrder } from '../domain/FormBuilder/FormBuilderPage'

function generateId() {
  return parseInt(Math.random() * 1000000000000000).toString()
}

function duplicatiateQuestionChoiceDefaultValue(question, choicesMap) {
  const defaultValues = question.default_value?.split(',')
  const duplicatedDefaultValues = []
  for (const defaultValue of defaultValues) {
    if (choicesMap[defaultValue]) {
      duplicatedDefaultValues.push(choicesMap[defaultValue])
    }
  }
  return duplicatedDefaultValues.join(',')
}

function duplicateDefaultValue(question, choicesMap) {
  if (!question.default_value) return question.default_value

  if (!['radio', 'checkbox'].includes(question.question_type.question_type)) {
    return question.default_value
  }

  return duplicatiateQuestionChoiceDefaultValue(question, choicesMap)
}

export function generateDuplicateQuestion(
  originalQuestion,
  newRowId,
  newSection = null
) {
  const newQuestionId = generateId()
  const choicesMap = {}
  const duplicatedQuestion = {
    ...originalQuestion,
    id: newQuestionId,
    original_id: newQuestionId,
    athena_integration: null,
    chirotouch_integration: null,
    elation_integration: null,
    open_dental_integration: null,
    row: newRowId,
    section: newSection || originalQuestion.section,
    hasChanged: false,
    isNew: true,
    conditional_rule_groups: [],
    demographics: '',
    question_choices: map(
      originalQuestion.question_choices,
      (originalChoice) => {
        const choiceId = generateId()
        choicesMap[originalChoice.id] = choiceId
        return {
          ...originalChoice,
          id: choiceId,
          original_id: choiceId,
          question: newQuestionId,
          isNew: true,
        }
      }
    ),
    question_columns: map(
      originalQuestion.question_columns,
      (originalColumn) => ({
        ...originalColumn,
        id: generateId(),
        original_id: generateId(),
        question: newQuestionId,
        isNew: true,
      })
    ),
    question_rows: map(originalQuestion.question_rows, (originalColumn) => ({
      ...originalColumn,
      id: generateId(),
      original_id: generateId(),
      question: newQuestionId,
      isNew: true,
    })),
    form_index: getRandomDigitString(),
  }

  duplicatedQuestion.default_value = duplicateDefaultValue(
    duplicatedQuestion,
    choicesMap
  )

  return duplicatedQuestion
}

export function handleNewPage(prevPages, newPage, whereToAdd) {
  return mapValues({ ...prevPages, [newPage.id]: newPage }, (page) => {
    if (page.order < newPage.order || page.id === newPage.id) {
      return page
    }
    return increasePageOrder(page)
  })
}

export function handleAddTrailRowOnFormOrder(
  prevFormOrder,
  targetSection,
  newRowId
) {
  return [
    {
      ...prevFormOrder[0],
      pages: map(prevFormOrder[0].pages, (page) => ({
        ...page,
        sections: map(page.sections, (section) =>
          section.id !== targetSection
            ? section
            : {
                ...section,
                rows: [
                  {
                    id: newRowId,
                    questions: [],
                  },
                  ...section.rows,
                ],
              }
        ),
      })),
    },
  ]
}
